export function composeUnversionedStaticsPath (link, unversionedStaticsPath) {
  return (link.substring(0, 2) !== '//' && link.substring(0, 7) !== 'http://' && link.substring(0, 8) !== 'https://')
    ? `${unversionedStaticsPath}${link}`
    : link
}
